import type { JsonPost } from "./schema";
import { SITE_URL, articleLd, breadcrumbLd, faqLd, type Lang } from "@/lib/seo";

export function jsonPostSeo(post: JsonPost, lang: Lang) {
  const copy = post[lang];
  const path = lang === "fr" ? post.frPath : post.enPath;
  const url = `${SITE_URL}${path}`;
  const image = `${SITE_URL}${post.cover.src}`;
  return {
    path, image,
    blocks: [
      { id: "article", data: articleLd({ lang, url, headline: copy.h1, description: copy.metaDescription, image, section: copy.category, datePublished: post.datePublished, dateModified: post.dateModified, keywords: copy.keywords }) },
      { id: "breadcrumb", data: breadcrumbLd([
        { name: lang === "fr" ? "Accueil" : "Home", url: `${SITE_URL}${lang === "fr" ? "/" : "/en"}` },
        { name: "Blog", url: `${SITE_URL}${lang === "fr" ? "/blog" : "/en/blog"}` },
        { name: copy.breadcrumb, url },
      ]) },
      ...(copy.faq.length ? [{ id: "faq", data: faqLd(copy.faq, `${url}#faq`) }] : []),
    ],
  };
}
